import { observable, action } from "mobx";
import { createContext } from "react";
import { IWorkorder } from "../models/workorder";
import agent from "../api/agent";
import { IWorkOrderSOR } from "../models/workordersor";
import { INote } from "../models/note";
import { IVariation } from "../models/variation";
import { Iappointments } from "../models/appointments";


class WorkOrderStore {
  
  @observable workorders: IWorkorder[] = [];
  @observable agedDebt: IWorkorder[] = [];

  @observable selectedWorkOrder: IWorkorder | undefined = undefined;
  @observable selectedWorkOrderSors: IWorkOrderSOR[] = [];
  @observable selectedWorkOrderNotes: INote[] = [];
  @observable selectedWorkOrderVariations: IVariation[] = [];
  @observable selectedWorkOrderAppointment: Iappointments[] = [];
  @observable loadinginitial = false;

  @action loadWorkOrders = (fnc: string, username:string, client:string) => {
    this.loadinginitial = true;
    agent.Workorders.list({
      clientid: client, 
      username: username,
      timestamp: new Date(),
      function: fnc,
    })
      .then(resp => (this.workorders = resp))
      .catch(error => {
        alert("Load Work Order Error: " + error);
      })
      .finally(() => (this.loadinginitial = false));
  };

@action loadWorkOrderSors = (id: string, username:string) => {
  if (username == null)
    username = ""  
  agent.WorkOrderSORS.list({
      clientid: "2B28C4A2-0894-E911-A978-002248072ABD", //CCHA For Now!
      username: username,
      wrkOrdId: id,
      timestamp: new Date()
    })
      .then(resp => (this.selectedWorkOrderSors = resp))
      .catch(error => {
        alert("Load Work Order SORS Error: " + error);
      });
  };


  @action loadAgedDebt = (client: string) => {
    this.loadinginitial = true;
    agent.AgedDebt.list({
      clientid: client, //CCHA For Now!
    })
      .then(resp => {
        this.workorders = resp
        console.log(resp)
      })
      .catch(error => {
        alert("Aged Debt error: " + error);
      }).finally(() => (this.loadinginitial = false));
  };

  @action loadWorkOrderNotes = (id: string, username: string) => {
    if (username == undefined || username == null)
      username = ""
    agent.WorkOrderNotes.list({
      clientid: "2B28C4A2-0894-E911-A978-002248072ABD", //CCHA For Now!
      username: username,
      wrkOrdId: id,
      timestamp: null
    })
      .then(resp => {
        this.selectedWorkOrderNotes = resp
        console.log(resp)
      })
      .catch(error => {
        alert("Load Work Order Notes Error: " + error);
      });

      console.log("getting notes");
  };

  @action loadWorkOrderVariations = (id: string, username:string) => {
    agent.WorkOrderVariationHistory.list({
      clientid: "2B28C4A2-0894-E911-A978-002248072ABD", //CCHA For Now!
      //username: "Jonathan Nachman",
      username: username,
      wrkOrdId: id,
      timestamp: new Date()
    })
    .then(resp => (this.selectedWorkOrderVariations = resp))
        .catch(error => {
        alert("Load Work Osrder Variations Error: " + error);
      });
  };

  @action loadWorkOrderAppointments = (id: string, username: string) => {
    if (username == null)
      username = ""
    agent.Appointments.list({
      username: username,
      JobNo: id,
    })
    .then(resp => {
      //this.selectedWorkOrderAppointment = resp;
      //ADD240118 -change to filter out dummy appointment after year 2099 
      console.log('resp:',resp);
      let result = resp.filter((item)=>{return (new Date(item.StartTime) < new Date(new Date(2099,12,31).toDateString()));})
      this.selectedWorkOrderAppointment = result;
    })
      .catch(error => {
        alert("Test Error: " + error);
      });
  };

  @action selectWorkOrder = (id: string, username:string) => {
    console.log("trying")
    this.selectedWorkOrderSors = [];
    this.selectedWorkOrder = this.workorders.find(x => x.JobId === id);
    this.loadWorkOrderSors(id, username);
    this.loadWorkOrderNotes(id, username);
    this.loadWorkOrderVariations(id, username);
    this.loadWorkOrderAppointments(id, username);
 
  };

 
}

//Create new store in react context
export default createContext(new WorkOrderStore());
